import {atomWithReset} from 'jotai/utils'

export enum EGameMode {
  NONE = 'none',
  SINGLE_PLAYER = 'single_player',
  PARTY = 'party',
}

export const gameModeState = atomWithReset<EGameMode>(EGameMode.NONE)
